import { v4 as uuidv4 } from 'uuid';

const widget = (type, position) => ({ id: uuidv4(), type, recordingId: null, sensorKey: null, position });

/**
 * The panels a workspace opens with, laid out once when its first recording
 * arrives. Row one is video / rules / notes across twelve columns; row two is
 * the sensor chart full width.
 *
 * A sensors-only recording has nothing to play, so the video panel is dropped
 * and the remaining two slide left rather than leaving a hole.
 */
export default function starterWidgets({ hasVideo }) {
  const widgets = [];
  if (hasVideo) widgets.push(widget('unified_video', { x: 0, y: 0, w: 4, h: 4 }));
  widgets.push(widget('rules', { x: hasVideo ? 4 : 0, y: 0, w: 4, h: 4 }));
  widgets.push(widget('notes', { x: hasVideo ? 8 : 4, y: 0, w: 4, h: 4 }));
  widgets.push(widget('timeline_sensor_chart', { x: 0, y: 4, w: 12, h: 4 }));
  return widgets;
}
